export default __webpack_public_path__ + "static/media/lens.94b33e7f.svg";